import PropTypes from "prop-types"
import { LIGHT_MODE__BKG_ALT } from "@/libs/constants"
import * as styles from "@/styles/modules/MovingGradientLite.module.scss"

const MovingGradient = props => {
  return (
    <div
      className={styles.wrapper}
      style={
        props.backgroundColor
          ? { backgroundColor: props.backgroundColor }
          : null
      }
    />
  )
}

MovingGradient.defaultProps = {
  backgroundColor: LIGHT_MODE__BKG_ALT,
  particleColors: [
    "#5822F3", // periwinkle
    "#31C9FF", // sky
    "#91EDD9", // light teal
    "#FFA3D5", // light pink
    "#F84FAA", // pink
  ],
}

MovingGradient.propTypes = {
  particleColors: PropTypes.arrayOf(PropTypes.string),
}

export default MovingGradient
